<template>
  <v-dialog transition="dialog-top-transition" max-width="600" v-model="dialog">
    <v-card>
      <v-toolbar :color="colorDialog" dark>{{ tituloDialogForm }}</v-toolbar>
      <v-card-text>
        <div class="text-h6 pa-12">
          {{ mensajeDelDialog }}
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="primary" @click="devolverValor(2)">Operador</v-btn>
        <v-btn color="primary" @click="devolverValor(3)">Contratista</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    bandera: 0,
    colorDialog: "",
    dialog: "",
    mensajeDelDialog: "",
    tituloDialogForm: "",
  }),

  methods: {
    async abrirMensajeDialog(mensaje, dato, color, titulo) {
      this.mensajeDelDialog = mensaje;
      this.bandera = dato;
      this.colorDialog = color;
      this.tituloDialogForm = titulo;
      this.dialog = true;
    },

    devolverValor(valor) {
      console.log("Ingreso en deovler valor");
      console.log("la opcion seleccionada es: ");
      console.log(valor);
      this.dialog = false;
      this.$emit("resultado", valor);
    },

    cerrarModal() {
      console.log("Presiono cerrar");
      this.dialog = false;
      console.log("El valor del dialog es:");
      console.log(this.dialog);
    },
  },
};
</script>
